import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonConverter } from '@app-core/services/utility/json-conveter';
import { AddDelivery } from '@app-units/models/add-delivery/add-delivery';
import { AddDeliveryOriginInterface } from '@app-units/models/add-delivery/add-delivery-origin';
import { ArticleConstructionInfo } from '@app-units/models/article-construction-info/article-construction-info';
import { ArticleConstructionInfoOriginInterface } from '@app-units/models/article-construction-info/article-construction-info-origin';
import { Observable } from 'rxjs';

@Injectable()
export class AddDeliveryHttpService {
  constructor(private http: HttpClient) {}

  fetchItems(id: string): Observable<app.response<AddDelivery>> {
    return this.http
      .get(this.getUrl(id))
      .pipe(map(JsonConverter.toAddDelivery));
  }

  saveItem(
    item: AddDeliveryOriginInterface
  ): Observable<app.response<AddDelivery>> {
    return this.http
      .put(this.getUrl(String(item.id)), item)
      .pipe(map(JsonConverter.toAddDelivery));
  }

  private getUrl(id: string) {
    return `/orders/${id}/add_delivery`;
  }
}
